import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSaleMandates, getSaleMandate, createSaleMandate, updateSaleMandate, deleteSaleMandate } from '../api/saleMandates';
import { SaleMandatesListParams, SaleMandate } from '../types';

export function useSaleMandates(params: SaleMandatesListParams = {}) {
  return useQuery({
    queryKey: ['sale-mandates', params],
    queryFn: () => getSaleMandates(params),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}

export function useSaleMandate(id: string) {
  return useQuery({
    queryKey: ['sale-mandate', id],
    queryFn: async () => {
      const result = await getSaleMandate(id);
      return result.data;
    },
    staleTime: 0,
    refetchOnMount: 'always',
  });
}

export function useCreateSaleMandate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSaleMandate,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sale-mandates'] }),
  });
}

export function useUpdateSaleMandate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<SaleMandate> }) =>
      updateSaleMandate(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sale-mandates'] }),
  });
}

export function useDeleteSaleMandate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSaleMandate,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sale-mandates'] }),
  });
}
